import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import { fetchAggResponse } from '../../../../common';
import { fetchRestResponse } from '../../../../common/fetch';
import { SearchSourceQuery } from '../../gql/search-source-query';
import { getQuerySpecsPerEntity } from './utils';
var OBJECT_RESOLVE_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
export var useSearchSourceSupplier = function useSearchSourceSupplier() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var cloudId = commonAttributes.cloudId,
    extraAttributes = commonAttributes.extraAttributes;
  var readingAidsSessionId = extraAttributes.readingAidsSessionId;
  var searchSources = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
      var _details$0$body$data$, _details;
      var _getQuerySpecsPerEnti, searchQuery, entities, spacesFilter, needsLinkResolution, details;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getQuerySpecsPerEnti = getQuerySpecsPerEntity(query), searchQuery = _getQuerySpecsPerEnti.searchQuery, entities = _getQuerySpecsPerEnti.entities, spacesFilter = _getQuerySpecsPerEnti.spacesFilter, needsLinkResolution = _getQuerySpecsPerEnti.needsLinkResolution;
            if (!needsLinkResolution) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return fetchRestResponse({
              url: OBJECT_RESOLVE_ENDPOINT,
              body: [{
                resourceUrl: query.split('?')[0]
              }]
            });
          case 4:
            details = _context.sent;
          case 5:
            return _context.abrupt("return", fetchAggResponse({
              graphQuery: SearchSourceQuery,
              variables: {
                experience: 'curated-definition-source-search',
                analytics: {
                  searchSessionId: readingAidsSessionId
                },
                query: (_details$0$body$data$ = (_details = details) === null || _details === void 0 || (_details = _details[0]) === null || _details === void 0 || (_details = _details.body) === null || _details === void 0 || (_details = _details.data) === null || _details === void 0 ? void 0 : _details.name) !== null && _details$0$body$data$ !== void 0 ? _details$0$body$data$ : searchQuery,
                filters: {
                  entities: entities,
                  locations: [cloudId ? "ari:cloud:confluence::site/".concat(cloudId) : ''],
                  confluenceFilters: {
                    titleMatchOnly: true,
                    spacesFilter: spacesFilter
                  }
                },
                first: 5
              }
            }).then(function (response) {
              if (response.data) {
                return response.data.search.results.edges.map(function (edge) {
                  var _edge$node, _edge$node2, _edge$node3, _edge$node4, _edge$node5, _edge$node6, _edge$node7;
                  return {
                    id: ((_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.id) || '',
                    type: ((_edge$node2 = edge.node) === null || _edge$node2 === void 0 ? void 0 : _edge$node2.type) || '',
                    title: ((_edge$node3 = edge.node) === null || _edge$node3 === void 0 ? void 0 : _edge$node3.title) || '',
                    container: ((_edge$node4 = edge.node) === null || _edge$node4 === void 0 || (_edge$node4 = _edge$node4.space) === null || _edge$node4 === void 0 ? void 0 : _edge$node4.name) || '',
                    url: ((_edge$node5 = edge.node) === null || _edge$node5 === void 0 ? void 0 : _edge$node5.url) || '',
                    iconUrl: ((_edge$node6 = edge.node) === null || _edge$node6 === void 0 ? void 0 : _edge$node6.iconUrl) || '',
                    lastModified: ((_edge$node7 = edge.node) === null || _edge$node7 === void 0 ? void 0 : _edge$node7.lastModified) || ''
                  };
                });
              }
              return [];
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [cloudId, readingAidsSessionId]);
  return {
    searchSources: searchSources
  };
};